import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiCopyAlt } from 'react-icons/bi';
import { toast } from 'react-toastify';

import { PSButton } from '@/components/ui/button';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

interface Props {
  sumId: string;
}

const AffiliationShareBlock: React.FC<Props> = ({ sumId }) => {
  const { t } = useTranslation();

  const affiliationLink = `${import.meta.env.VITE_UI_ADDRESS ?? 'https://louisebot.com'}?bp_id=${sumId}_idBP`;

  const handleCopyToClipboard = (content?: string) => {
    navigator.clipboard.writeText(content ?? affiliationLink).then(() => {
      toast.success('Copied!');
    });
  };

  return (
    <div className="tw-w-full tw-px-6 tw-pt-4 tw-pb-6 tw-bg-white tw-rounded-2xl tw-shadow tw-flex-col tw-justify-start tw-items-start tw-gap-6 tw-inline-flex">
      <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-4 tw-flex">
        <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-1 tw-flex">
          <div className="tw-text-gray-800 tw-text-lg tw-font-semibold tw-font-['Lexend'] tw-leading-7">{t('BusinessPartner/AffiliationLink/title')}</div>
          <div className="tw-self-stretch tw-text-gray-500 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none tw-text-left">
            {t('BusinessPartner/AffiliationLink/text1')}
          </div>
        </div>
      </div>
      <div className="tw-grid tw-grid-cols-2 tw-gap-10">
        <div className="lg:tw-col-span-1 tw-col-span-2 tw-flex tw-flex-col tw-gap-2">
          <div className="tw-text-left tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
            {t('BusinessPartner/AffiliationLink/text2')}
          </div>
          <div className="tw-self-stretch tw-justify-start tw-items-start tw-gap-3 tw-inline-flex lg:tw-flex-row tw-flex-col">
            <div className="lg:tw-w-[80%] tw-w-full tw-px-5 tw-py-2.5 tw-min-h-[40px] tw-bg-gray-100 tw-rounded-3xl tw-justify-start tw-items-center tw-gap-2 tw-flex">
              <div className="tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight tw-text-left tw-truncate">{affiliationLink}</div>
            </div>
            <PSButton id="btn-affiliate-copy" variant="outline" onClick={() => handleCopyToClipboard()} icon={<BiCopyAlt className="tw-shrink-0" />}>
              {t('BusinessPartner/AffiliationLink/copy')}
            </PSButton>
          </div>
        </div>
        <div className="lg:tw-col-span-1 tw-col-span-2 tw-flex tw-flex-col tw-gap-2">
          <div className="tw-text-left tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
            {t('BusinessPartner/AffiliationLink/text3')}
          </div>
          <div className="tw-self-stretch tw-justify-start tw-items-start tw-gap-3 tw-inline-flex lg:tw-flex-row tw-flex-col">
            <div className="lg:tw-grow tw-w-full tw-px-5 tw-py-2.5 tw-min-h-[40px] tw-bg-gray-100 tw-rounded-3xl tw-justify-start tw-items-center tw-gap-2 tw-flex">
              <div className="tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight tw-truncate">
                ?{affiliationLink.split('?').pop()}
              </div>
            </div>
            <PSButton
              id="btn-affiliate-copy-link"
              variant="outline"
              onClick={() => handleCopyToClipboard(`?${affiliationLink.split('?').pop()}`)}
              icon={<BiCopyAlt className="tw-shrink-0" />}
            >
              {t('BusinessPartner/AffiliationLink/copy')}
            </PSButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(AffiliationShareBlock);
